export const CHECK_PHONE_EXISTS = "CHECK_PHONE_EXISTS";
export const CHECK_PHONE_EXISTS_FAILED = "CHECK_PHONE_EXISTS_FAILED";
export const CHECK_PHONE_EXISTS_SUCCESS = "CHECK_PHONE_EXISTS_SUCCESS";

export const REQUEST_NEW_OTP_CODE = "REQUEST_NEW_OTP_CODE";
export const REQUEST_NEW_OTP_CODE_FAILED = "REQUEST_NEW_OTP_CODE_FAILED";
export const REQUEST_NEW_OTP_CODE_SUCCESS = "REQUEST_NEW_OTP_CODE_SUCCESS";

export const VERIFY_CODE = "VERIFY_CODE";
export const VERIFY_CODE_FAILED = "VERIFY_CODE_FAILED";
export const VERIFY_CODE_SUCCESS = "VERIFY_CODE_SUCCESS;";

export const UPDATE_PASSWORD_PIN = "UPDATE_PASSWORD_PIN";
export const UPDATE_PASSWORD_PIN_FAILED = "UPDATE_PASSWORD_PIN_FAILED";
export const UPDATE_PASSWORD_PIN_SUCCESS = "UPDATE_PASSWORD_PIN_SUCCESS";

export const UPDATE_BIZ_ACCOUNT_PASSWORD = "UPDATE_BIZ_ACCOUNT_PASSWORD";
export const UPDATE_BIZ_ACCOUNT_PASSWORD_FAILED = "UPDATE_BIZ_ACCOUNT_PASSWORD_FAILED";
export const UPDATE_BIZ_ACCOUNT_PASSWORD_SUCCESS = "UPDATE_BIZ_ACCOUNT_PASSWORD_SUCCESS";

export const FORGOT_PASSWORD_PIN = "FORGOT_PASSWORD_PIN";
export const FORGOT_PASSWORD_PIN_FAILED = "FORGOT_PASSWORD_PIN_FAILED";
export const FORGOT_PASSWORD_PIN_SUCCESS = "FORGOT_PASSWORD_PIN_SUCCESS;";

// Phone Status
export const PHONE_NOT_EXIST = 'NONE'; // Phone not exists in database => go to ValidateOTP step
export const PHONE_NOT_CONFIRMED_OTP = 'PHONE_NOT_CONFIRMED_OTP'; // Phone didn't confirm OTP yet => go to ValidateOTP step
export const OTP_NO_CONFIRMED = 'OTP_NO_CONFIRMED'; // Phone didn't confirm OTP yet => go to ValidateOTP step
export const OTP_CONFIRMED = 'OTP_CONFIRMED'; // Phone confirmed OTP but not update PIN => go to UpdateProfile step
export const PASSWORD_EXIST = 'PASSWORD_EXIST'; // Phone already updated password => go to ValidatePassword step
export const NEW_ACCOUNT = 'NEW_ACCOUNT'; // Phone already updated password => go to ValidatePassword step
export const NONE = 'NONE'; // biz account, account is not exist
export const ACCOUNT_LOCK = 'ACCOUNT_LOCK'; // biz account, account is not exist

export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const REQUEST_LOGIN_SUCCESS = 'REQUEST_LOGIN_SUCCESS';
export const REQUEST_LOGIN_FAILED = 'REQUEST_LOGIN_FAILED';

export const RESET_STATE = 'RESET_STATE';

export const GET_PROFILE_BIZ_CUSTOMER = 'GET_PROFILE_BIZ_CUSTOMER';
export const GET_PROFILE_BIZ_CUSTOMER_SUCCESS = 'GET_PROFILE_BIZ_CUSTOMER_SUCCESS';
export const GET_PROFILE_BIZ_CUSTOMER_FAILED = 'GET_PROFILE_BIZ_CUSTOMER_FAILED';

export const STORE_BIZ_ACCOUNT_CURRENT_PASSWORD = 'STORE_BIZ_ACCOUNT_CURRENT_PASSWORD';
export const STORE_BIZ_ACCOUNT_CUSTOMER_CODE = 'STORE_BIZ_ACCOUNT_CUSTOMER_CODE';
export const CREATE_BIZ_ACCOUNT = 'CREATE_BIZ_ACCOUNT';
export const CREATE_BIZ_ACCOUNT_SUCCESS = 'CREATE_BIZ_ACCOUNT_SUCCESS';
export const CREATE_BIZ_ACCOUNT_FAILED = 'CREATE_BIZ_ACCOUNT_FAILED';
export const GET_LOCATION = 'GET_LOCATION';
export const GET_LOCATION_SUCCESS = 'GET_LOCATION_SUCCESS';